import { FALLBACK_ERROR_MESSAGE } from 'appConstants';
import ErrorMessage from 'components/errorMessage/ErrorMessage';
import React from 'react';

const ErrorFallback: React.FC = () => {
  return <ErrorMessage message={FALLBACK_ERROR_MESSAGE} />;
};

export default ErrorFallback;
